import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Ab wann hat Sandra eine Verbesserung bemerkt?',
  a: 'Bereits nach 7–10 Tagen zeigte Balu deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
}, {
  q: 'Ist das Topping auch für empfindliche Hunde geeignet?',
  a: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
}, {
  q: 'Wie viel gibt man täglich?',
  a: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Sandra hat mit der kleinsten Menge angefangen und langsam gesteigert.'
}, {
  q: 'Was wenn es bei meinem Hund nicht wirkt?',
  a: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full py-16 px-4 bg-cream" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-85">
          <h2 className="font-handwriting text-4xl md:text-5xl text-forest" data-id="element-86">
            Häufige Fragen
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-brown-light/20 overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-89">
                <span className="font-serif font-semibold text-lg text-brown-dark pr-4" data-id="element-90">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-forest transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>

              <AnimatePresence data-id="element-92">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="px-6 pb-5 pt-1 font-serif text-brown-dark/80 leading-relaxed" data-id="element-94">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}